import { makeAutoObservable } from 'mobx';
import { BrokerSectionDto } from '../../../../../defs/api';
import { RealizedReportTradeMobxDto } from './realized-report-trade-mobx-dto';
import { UnrealizedReportTradeMobxDto } from './unrealized-report-trade-mobx-dto';
import { DividendMobxDto } from '../../dividend/dividend-mobx-dto';

export class BrokerSectionMobxDto implements BrokerSectionDto {
    public brokerName: string | null = null;

    public realizedReportTrades: RealizedReportTradeMobxDto[] = [];

    public unrealizedReportTrades: UnrealizedReportTradeMobxDto[] = [];

    public dividends: DividendMobxDto[] = [];

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: BrokerSectionDto): BrokerSectionMobxDto {
        const mobxDto = new BrokerSectionMobxDto();

        return Object.assign(mobxDto, dto, {
            realizedReportTrades: RealizedReportTradeMobxDto.createFromArray(dto.realizedReportTrades),
            unrealizedReportTrades: UnrealizedReportTradeMobxDto.createFromArray(dto.unrealizedReportTrades),
            dividends: DividendMobxDto.createFromArray(dto.dividends),
        });
    }

    static createFromArray(dtos: BrokerSectionDto[]): BrokerSectionMobxDto[] {
        return dtos.map((dto) => BrokerSectionMobxDto.create(dto));
    }
}
